import { render } from "./MinButton.vue?vue&type=template&id=10577a24"
import script from "./MinButton.vue?vue&type=script&lang=js"
export * from "./MinButton.vue?vue&type=script&lang=js"

import "./MinButton.vue?vue&type=style&index=0&id=10577a24&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/MinButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10577a24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10577a24', __exports__)) {
    api.reload('10577a24', __exports__)
  }
  
  module.hot.accept("./MinButton.vue?vue&type=template&id=10577a24", () => {
    api.rerender('10577a24', render)
  })

}


export default __exports__